import { Inject, Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { Article } from '../model/article.model';
import { Facet } from '../model/facet.model';
import { CATALOG_CONFIG, CatalogConfig, PageViewConfig } from '../config/catalog.config';
import { SortByType } from '../model/sort-by.type';
import { ViewModeType } from '../model/view-mode.type';

export interface CachedArticleHits<H, C> {
  id: string;
  totalHits: number;
  hits: H[];
  config?: C;
  queryFilters?: any;
}

export interface ProductFacetedSearchState {
  articles: Article[];
  facets: Facet[];
  totalHits: number;
  cachedHits: CachedArticleHits<Article, PageViewConfig>[];
  pageIndex: number;
  pageSize: number;
  sortBy: SortByType;
  viewMode: ViewModeType;
}

function createInitialState(catalogConfig: CatalogConfig): ProductFacetedSearchState {
  return {
    articles: [],
    facets: [],
    totalHits: 0,
    cachedHits: [],
    ...catalogConfig,
  };
}

@Injectable()
@StoreConfig({ name: 'product-faceted-search' })
export class ArticleFacetedSearchStore extends Store<ProductFacetedSearchState> {
  constructor(@Inject(CATALOG_CONFIG) private catalogConfig: CatalogConfig) {
    super(createInitialState(catalogConfig));
  }
}
